import React from 'react';
import { useFormContext } from 'react-hook-form';

const PaymentSection = () => {
  const { register, formState: { errors }, watch } = useFormContext();
  
  // Watch paymentMethod and paymentTerms to ensure they're properly displayed
  const paymentMethod = watch('paymentMethod');
  const paymentTerms = watch('paymentTerms');
  const paymentMethodOther = watch('paymentMethodOther');

  return (
    <div className="payment-section">
      <h3 className="form-section-title">Payment Information</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="paymentMethod">Payment Method</label>
          <select
            id="paymentMethod"
            {...register('paymentMethod')}
            value={paymentMethod || ''}
            className={errors.paymentMethod ? 'error' : ''}
          >
            <option value="" disabled hidden>Select Payment Method</option>
            <option value="ACH">ACH</option>
            <option value="Wire">Wire</option>
            <option value="Check">Check</option>
            <option value="Credit Card">Credit Card</option>
            <option value="Cash">Cash</option>
            <option value="Zelle">Zelle</option>
            <option value="Factoring">Factoring</option>
            <option value="Other">Other</option>
          </select>
          {errors.paymentMethod && (
            <span className="error-message">{errors.paymentMethod.message}</span>
          )}
        </div>
        {paymentMethod === 'Other' && (
          <div className="form-group">
            <label htmlFor="paymentMethodOther">Other Payment Method</label>
            <input
              type="text"
              id="paymentMethodOther"
              placeholder="Enter payment method"
              {...register('paymentMethodOther')}
              value={paymentMethodOther || ''}
              className={errors.paymentMethodOther ? 'error' : ''}
            />
            {errors.paymentMethodOther && (
              <span className="error-message">{errors.paymentMethodOther.message}</span>
            )}
          </div>
        )}
        <div className="form-group">
          <label htmlFor="paymentTerms">DTP</label>
          <select
            id="paymentTerms"
            {...register('paymentTerms')}
            value={paymentTerms ? String(paymentTerms) : ''}
            className={errors.paymentTerms ? 'error' : ''}
          >
            <option value="" disabled hidden>Select DTP</option>
            {Array.from({ length: 90 }, (_, i) => i + 1).map((day) => (
              <option key={day} value={String(day)}>
                {day} {day === 1 ? 'day' : 'days'}
              </option>
            ))}
          </select>
          {errors.paymentTerms && (
            <span className="error-message">{errors.paymentTerms.message}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentSection;

